import { render, staticRenderFns } from "./DeliveryRequest.vue?vue&type=template&id=0d0d3c46&scoped=true&lang=pug&"
import script from "./DeliveryRequest.js?vue&type=script&lang=js&"
export * from "./DeliveryRequest.js?vue&type=script&lang=js&"
import style0 from "./DeliveryRequest.vue?vue&type=style&index=0&id=0d0d3c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d3c46",
  null
  
)

export default component.exports